import React from "react";
import {connect} from 'react-redux'
import clsx from 'clsx';
import _ from 'lodash'

import withStyles from '@material-ui/core/styles/withStyles';

import styles from "./styles";
import SideMenuTriggerButton from "./components/SideMenuTriggerButton";
import NotificationItem from "./components/NotificationItem";
import ReportGenerationHandler from "../../../../components/ReportsGenerationHandler/ReportGenerationHandler";
import {shortNumber} from "../../utils";
import DropDownIcon from "./components/DropDownIcon";
import UserMenu from "./components/UserMenu";
import {getOriginLink} from "../../../../utils/constants";
import CustomerData from "./components/CustomerData";
import InfoTourButton from "../../../../components/Buttons/InfoTourButton";
import useWindowSize from '../../../../components/WindowSizeHook';
import {getAlertingNotificationsCountSplitted, getInvestmentPlatformSelector} from "../../../../utils/redaxSelectors";
import {ALERT_PRODUCT_TYPE} from "../../../RiskDashboard/components/AlertConfigurationModal/utils";

const mapStateToProps = (state) => ({
  investmentPlatform: getInvestmentPlatformSelector(state),
  alertingNotificationsCountSplitted: getAlertingNotificationsCountSplitted(state)
});

const ALERTS_PAGE = '/#/Kunden/Mitteilungen/Alarme';
const ALERTS_PAGE_FOR_OTHER_ASSETS = `${ALERTS_PAGE}?tab=other_assets_and_liabilities`;

const handleLinkClick = (path) => {
  window.location = path.startsWith('/') ? getOriginLink(path) : path;
};

const Header = props => {
  const {
    userData,
    userLogo,
    classes,
    onTriggerMenuClick,
    open,
    handleLogoutClick,
    routes,
    alertingNotificationsCountSplitted
  } = props;

  const { width } = useWindowSize(0);
  const [adviceDropdownOpened, setAdviceDropdownOpened] = React.useState(false);
  const [userDropdownOpened, setUserDropdownOpened] = React.useState(false);

  const getBadgeValue = React.useCallback((field) => {
      const _getNotificationCount = (fieldName) => {
        const notificationData = _.get(userData, fieldName);

        return _.get(notificationData, 'isEnabled') ? notificationData.count : 0;
      }

    if (!_.isArray(field)) {
      return _getNotificationCount(field);
    } else {
      return field.reduce((previousResult, fieldName) => {
        return previousResult + _getNotificationCount(fieldName);
      }, 0)
    }

  }, [userData]);

  const dropdownItems = React.useMemo(() => {
    const getAlertNotificationValue = (field) => {
      return !alertingNotificationsCountSplitted ? 0 : alertingNotificationsCountSplitted[field]
    };

    return [
      {key: 2, name: 'Offene Beratungen', path: '/#/Kunden/Mitteilungen/Beratungen', value: getBadgeValue('consultations')},
      {key: 3, name: 'Anstehende Geburtstage', path: '/#/Kunden/Mitteilungen/Geburtstage', value: getBadgeValue('birthdays')},
      {key: 1, name: 'Ablaufende Legitimationen', path: '/#/Kunden/Mitteilungen/Legitimationen', value: getBadgeValue('legitimations')},
      {key: 6, name: 'Ausgelöster Produktalarm', path: ALERTS_PAGE, value: getAlertNotificationValue(ALERT_PRODUCT_TYPE.ASSET)},
      {key: 7, name: 'Ausgelöster Depotalarm', path: ALERTS_PAGE, value: getAlertNotificationValue(ALERT_PRODUCT_TYPE.DEPOT)},
      {key: 8, name: 'Ablaufende Vermögenswerte', path: ALERTS_PAGE_FOR_OTHER_ASSETS, value: getBadgeValue('expiringAssets')},
      {key: 9, name: 'Ablaufende Verbindlichkeiten', path: ALERTS_PAGE_FOR_OTHER_ASSETS, value: getBadgeValue('expiringLiabilities')},
      {key: 4, name: 'Dokumente (BiPRO)', path: '/#/Organizer/BiPRO-Dokumente', value: getBadgeValue('biProDocuments')},
      {key: 5, name: 'GDV-Daten', path: '/#/Organizer/GDV', value: getBadgeValue('gdvFile')},
    ]
  }, [getBadgeValue, alertingNotificationsCountSplitted])

  return (
    <>
      <div className={classes.headerContainer}>
        <div className={clsx(classes.headerSideContainer, open && classes.headerSideContainerOpen)}>
          <div className={classes.headerSideButtonWrapper}>
            <SideMenuTriggerButton onClick={onTriggerMenuClick} />
          </div>
          <div className={clsx(classes.headerLogo, !open && 'collapsed')}/>
        </div>
        <div className={clsx(classes.headerRightWrapper, open && 'menu-open')}>
        <div className={classes.headerSearchContainer}>
          <div>
            <CustomerData routes={routes}/>
          </div>
          <div className={classes.infoTourButton}>
            <InfoTourButton iconButton={width < 1150} />
          </div>
        </div>
        <div className={classes.headerNotificationContainer}>
          <div>
            <ReportGenerationHandler notificationItem />
          </div>
          <div>
           <NotificationItem faIcon={['far','file-alt']} onClick={() => handleLinkClick('/#/Organizer/Protokoll')} />
         </div>
          <div>
            <NotificationItem
              onClick={() => handleLinkClick('/#/Organizer/Postfach')}
              faIcon={['far','envelope']}
              badgeContent={shortNumber(getBadgeValue('mails'))}/>
          </div>
          <div>
            <NotificationItem
              onClick={() => handleLinkClick('/#/Organizer/Nachrichten/Posteingang')}
              faIcon={['far','comments']}
              badgeContent={shortNumber(getBadgeValue('chats'))}/>
          </div>
          <div>
            <DropDownIcon
              openAction={() => setAdviceDropdownOpened(true)}
              closeAction={() => setAdviceDropdownOpened(false)}
              open={adviceDropdownOpened}
              faIcon={['far','bell']}
              items={dropdownItems}
            />
          </div>
          <div>
            <UserMenu
              userData={userData}
              userLogo={userLogo}
              openAction={() => setUserDropdownOpened(true)}
              closeAction={() => setUserDropdownOpened(false)}
              handleLogoutClick={handleLogoutClick}
              open={userDropdownOpened}/>
          </div>
        </div>
        </div>
      </div>
    </>
  )
};

export default connect(mapStateToProps)(withStyles(styles)(Header));